
























import { Vue, Component, Prop } from "vue-property-decorator";
import { isEmptyOrWhiteSpace } from "@/utils/Common";

@Component
export default class DContainerLayout extends Vue {
  @Prop({ type: String, default: () => "" })
  navTitle!: string;

  @Prop({ type: Boolean, default: () => false })
  showBack!: boolean;

  @Prop({ type: String, default: () => "" })
  bodyCls!: boolean;

  get showNav() {
    const project = this.$store.state.project.info;
    return project && !isEmptyOrWhiteSpace(project.name);
  }

  created() {
    this.$store.commit("currentNavTitle", this.navTitle);
  }

  goBack() {
    this.$router.back();
  }
}
